<template>
  <div class="mic-com gift-packet-container">
    <div class="gift-packet" :style="goodsStyle">
      <GoodsChunk v-for="chunk in chunkList"
                  chunk-type="gift_packet"
                  :key="chunk.key"
                  :config="config"
                  :data="chunk"
                  :preview="preview">
        <template v-slot="{goods, index}">
          <GoodsCard
                  :index="index"
                  :key="goods.guid"
                  :config="config"
                  :data="goods"/>
        </template>
      </GoodsChunk>
      <div class="gift-packet-all-btn"
           v-if="config.show_all_btn&&config.goods_from===1"
           :style="{marin: config.goods_margin / 2 + 'px'}">
        <van-button size="large" :url="config.more_link_url">查看全部</van-button>
      </div>
      <div class="empty" v-if="!chunkList.length">
        <van-image src="https://files.1card1.cn/VipCloudSite/159168/20200401/1b6aee76ccef425594413a2a368d2986.png" style="height: 250px;"/>
      </div>
    </div>
  </div>
</template>

<script>
  import * as shop from '@/api/shop';
  import GoodsCard from "./GoodsCard";
  import ChunkList from '../mixins/ChunkList';
  import Common from '../mixins/Common';

  export default {
	name: 'GiftPacket',
	props: {},
	mixins: [Common, ChunkList],
	components: {GoodsCard},
	data() {
	  return {
		chunkList: [],
		observerKeys: [
		  'config.goods_from',
		  'config.guids',
		  'config.goods_number'
		],
		request: shop.getGiftList
	  };
	},
	created() {
	  this.observerWhenPreview();
	  this.createChunkList();
	},
	methods: {
	  getQuery(query) {
		return {
		  ...query,
		  order: this.config.order_rule
		};
	  }
	},
	computed: {}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .gift-packet-container {
    overflow: hidden;

    .gift-packet {
      overflow: hidden;
    }

    .gift-packet-all-btn {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
</style>
